import React, { createContext, useContext, useState, useEffect } from 'react';
import PocketBase from 'pocketbase';

const PocketBaseContext = createContext();

export const usePocketBase = () => {
  const context = useContext(PocketBaseContext);
  if (!context) {
    throw new Error('usePocketBase must be used within a PocketBaseProvider');
  }
  return context;
};

export const PocketBaseProvider = ({ children }) => {
  const [pb] = useState(() => new PocketBase('https://leaf-surrounded-my-book-hub.pockethost.io'));
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if user is already authenticated
    const token = localStorage.getItem('authToken');
    if (token) {
      pb.authStore.save(token, null);
      setUser(pb.authStore.model);
    }
    setLoading(false);

    // Listen for auth changes
    pb.authStore.onChange((token, model) => {
      if (token) {
        localStorage.setItem('authToken', token);
      } else {
        localStorage.removeItem('authToken');
      }
      setUser(model);
    });
  }, [pb]);

  const login = async (email, password) => {
    try {
      const authData = await pb.collection('users').authWithPassword(email, password);
      setUser(authData.record);
      return authData;
    } catch (error) {
      throw error;
    }
  };

  const logout = () => {
    pb.authStore.clear();
    localStorage.removeItem('authToken');
    setUser(null);
  };

  const apiCall = async (method, endpoint, data = null) => {
    try {
      setLoading(true);
      const token = localStorage.getItem('authToken');
      const headers = {
        'Content-Type': 'application/json',
      };
      
      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
      }

      const config = {
        method,
        headers,
      };

      if (data && method !== 'GET') {
        config.body = JSON.stringify(data);
      }

      const response = await fetch(`https://leaf-surrounded-my-book-hub.pockethost.io${endpoint}`, config);

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || `HTTP ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error(`API Error (${method} ${endpoint}):`, error);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  // Check if current user is admin
  const isAdmin = user?.email === 'anish.m.malhotra@gmail.com';

  const value = {
    pb,
    user,
    login,
    logout,
    loading,
    isAuthenticated: !!user,
    isAdmin,
    apiCall,
    setLoading
  };

  return (
    <PocketBaseContext.Provider value={value}>
      {children}
    </PocketBaseContext.Provider>
  );
};